import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom'; 
import {verifyRoutePermissions} from '../../../globalFunctions';
import styles from './styles.module.scss';
import { questions } from "./questionList";
import { MenuAcessibilidade } from "../../../components/MenuAcessibilidade";
import { BotaoAcessibilidade } from "../../../components/BotaoAcessibilidade";

export default function QuestionsRoute() {
  const [answers, setAnswers] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [formValid, setFormValid] = useState(false);
  const [jaRespondeu, setRespondeu] = useState(false);
  const [userAuth, setUserAuth] = useState({} );
  const navigate = useNavigate();
  const [acessivel,setAcessivel] = useState(false)
  const showMenuAcessibilidade = () => {
      setShowMenu(!showMenuAcessibilidade)
  }    
  const ModoAcessivel = () => {
      setAcessivel(!acessivel)
   }
   const [showAcessibilidade, setShowMenu] = useState(false);

  // Verifica se todas as perguntas foram respondidas
  const validateForm = () => {
    const allAnswered = questions.every((_, index) => {
      const questionKey = `question${index + 1}`;
      return answers[questionKey] !== undefined && answers[questionKey] !== "";
    });
    setFormValid(allAnswered);
  };

  useEffect(() => {
    validateForm(); // Verifica a validade do formulário sempre que `answers` muda
  }, [answers]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formValid) {
      return; // Não faz nada se o formulário não for válido
    }

    try {
      const requestData = {
        user_id: userAuth.id, // Use o ID do usuário dinamicamente
        ...answers
      };
      console.log('Enviando dados:', requestData);
      console.log(userAuth)
      
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/answers`, requestData);
      console.log('Resposta do servidor:', response);
      
      setSuccessMessage(response.data.message);
      navigate('/')
    } catch (error) {
      console.error("Erro ao enviar respostas:", error.response ? error.response.data : error.message);
      console.log(error.response.data)  
      if (error.response.data.message == "Respostas já foram enviadas para este usuário.") {
          setRespondeu(true)
        }
    }
  };

  const handleChange = (questionKey, value) => {
    setAnswers((prevAnswers) => ({ ...prevAnswers, [questionKey]: value }));
  };


  useEffect(() => {
    const user = verifyRoutePermissions(
        ['auth', 'email.verified'],
        navigate
    );

    if (typeof user === 'object') {
        setUserAuth(user);
    }
}, []);

  return (    
    <div className={`${styles.wrapper}`}>
        {showAcessibilidade && <MenuAcessibilidade ModoAcessivel={ModoAcessivel} OnPress={showMenuAcessibilidade} acessivel={acessivel}/>}
        <BotaoAcessibilidade
                
                clicar={() => setShowMenu(current => !current)}
                               />    
      <h2 className="titulo">QUESTIONÁRIO</h2>
      <p>Agora que você já utilizou a plataforma Trilogic de auxilio
         ao ensino e aprendizagem da Lógica de Programação, por favor responda 
         as próximas questões sobre sua percepção da qualidade do Trilogic, 
         marque a opção de acordo com o quanto você concorda ou discorda de cada afirmação.
 </p>
 <p>Todos os dados são coletados anonimamente e somente serão utilizados no contexto desta pesquisa.</p>
      {successMessage && <p>{successMessage}</p>}
      <form onSubmit={handleSubmit}>
        {questions.map((pergunta, index) => (
          <AnswerBox
            key={index}
            pergunta={pergunta}
            id={index + 1}
            handleChange={handleChange}
            answers={answers}
          />
        ))}
        <button type="submit" disabled={!formValid}>Enviar</button>
        {!formValid && <p className="error-message">Por favor, responda todas as perguntas antes de enviar.</p>}
        {jaRespondeu && <p className="error-message">Você já respondeu esse questionario, só é possivel enviar respostas uma vez</p>}

      </form>
    </div>
  );
}

const AnswerBox = ({ pergunta, id, handleChange, answers }) => {
  const questionKey = `question${id}`;

  return (
    <div className="question">
      <label>{pergunta}</label>
      <div className="options">
        {["Discordo totalmente", "Discordo", "Nem discordo, nem concordo", "Concordo", "Concordo totalmente"].map((option) => (
          <label key={`${questionKey}-${option}`}>
            <input
              type="radio"
              name={questionKey}
              value={option}
              checked={answers[questionKey] === option}
              onChange={(e) => handleChange(questionKey, e.target.value)}
            />
            {option}
          </label>
        ))}
      </div>
     
    </div>
  );
};
